/**
 * Memoized selectors for core store slices
 *
 * These selectors use reselect's createSelector to optimize performance
 * by memoizing results and only recalculating when inputs change.
 */

import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../types';

// Define base selectors for feature slices, but don't import their selectors directly
// This prevents circular dependencies
// Instead, these will be combined in the component layer as needed

// UI Selectors
export const selectUI = (state: RootState) => state.ui;

export const selectSidebarOpen = createSelector([selectUI], ui => ui.sidebarOpen);
